const environment = "prod"; // dev or prod

export const BASE_URL =
  environment === "dev" ? "http://localhost:1500/api" : "/api";

export const PUBLIC_URL = "https://appart9.vercel.app/";

export const API_URL = BASE_URL.replace(/:(\d+)/, "$1");
